import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './paymentInfoBox.scss';


@CSSModules(styles, { allowMultiple: true })
export default class PaymentInfoBox extends PureComponent {
    static propTypes = {
        title: PropTypes.node.isRequired,
        content: PropTypes.node.isRequired,
        icon: PropTypes.node,
        additional: PropTypes.node,
        footnote: PropTypes.node
    };

    render() {
        return (
            <section styleName="wrapper">
                <div styleName="title-wrapper">
                    {
                        this.props.icon &&
                        <div styleName="icon">
                            {this.props.icon}
                        </div>
                    }
                    <div styleName="title">
                        {this.props.title}
                    </div>
                    {
                        this.props.additional &&
                        <div styleName="additional">
                            {this.props.additional}
                        </div>
                    }
                </div>
                <div styleName="content">
                    {this.props.content}
                </div>
                {
                    this.props.footnote &&
                    <div styleName="footnote">
                        {this.props.footnote}
                    </div>
                }
            </section>
        );
    }

}

